import { Typography } from '@mui/material';
import { m } from 'framer-motion';
import { varFade } from 'src/components/animate';
import Category from 'src/features/components/category';
import { Container } from 'src/features/global';
import { StyledCategory, StyledContainer } from './styles';

// --------------------------------------------------------------------------------------

export default function Products() {
  return (
    <StyledContainer>
      <Container>
        <m.div variants={varFade().inUp}>
          <Typography variant="h4" align="center" mb={6}>
            Com o que trabalhamos?
          </Typography>
        </m.div>

        <StyledCategory variants={varFade().inUp}>
          <Category route="/toldos-lona" title="Toldos em Lona" url="images/catalogo/curvado.webp" />

          <Category
            route="/toldos-policarbonato"
            title="Toldos em Policarbonato"
            url="images/catalogo/policarbonato.webp"
          />

          <Category
            route="/toldos-garagem"
            title="Toldos Garagem"
            url="images/catalogo/toldogaragem.webp"
          />

          <Category
            route="/toldos-motorizados"
            title="Toldos Motorizados com Abertura por Controle Remoto"
            url="images/catalogo/motorizado.webp"
          />

          <Category
            route="/toldos-cortina"
            title="Toldos Cortina"
            url="images/catalogo/cortinas.webp"
          />

          <Category
            route="/estruturas-esquadrias"
            title="Estruturas e Esquadrias"
            url="images/catalogo/estruturas.webp"
          />

          <Category route="/sombriletes" title="Sombrites" url="images/catalogo/sombrite.webp" />

          <Category
            route="/grades-portoes"
            title="Grades e Portões"
            url="images/catalogo/grades.webp"
          />

          <Category
            disabledAnimate
            route="#"
            title="Motores e Cremalheiras para Portões"
            url="images/catalogo/motores.webp"
          />

          <Category disabledAnimate route="#" title="Fachadas" url="images/catalogo/fachadas.webp" />

          <Category
            disabledAnimate
            route="#"
            title="Totens Luminosos"
            url="images/catalogo/luminosos.webp"
          />
        </StyledCategory>
      </Container>
    </StyledContainer>
  );
}
